module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--file-a56d7cdaa70971cee18716bc97ce625d.svg";